<div #fieldWrapper class="date-range-selector-field" [class.is-active]="isMenuOpen || isFieldFocused">
    <mat-form-field appearance="outline" class="hide-hint w-100">
        <mat-label>{{ label }}</mat-label>
        <input #rangeInput readonly type="text" matInput [value]="displayText" (focus)="isFieldFocused = true"
            (blur)="isFieldFocused = false" />
        <button type="button" mat-icon-button matSuffix (click)="openMenu($event)">
            <mat-icon>calendar_today</mat-icon>
        </button>
    </mat-form-field>
    <span class="date-range-selector-menu-anchor" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
        (menuOpened)="onMenuOpened()" (menuClosed)="onMenuClosed()"></span>
</div>

<mat-menu #menu="matMenu" yPosition="below" xPosition="after" class="date-range-selector-menu-panel">
    <button type="button" mat-menu-item *ngFor="let option of options" (click)="selectOption(option)"
        [class.selected-option]="isSelected(option)">
        <span class="option-text">{{ (translateKeyPrefix + "." + option.displayOption) | translate }}</span>
        <mat-icon *ngIf="isSelected(option)" class="selected-check">check</mat-icon>
    </button>
    <button mat-menu-item type="button" (click)="openCustomRange()" [class.selected-option]="isCustomRangeSelected()">
        <span class="option-text">{{ (translateKeyPrefix + ".customRange") | translate }}</span>
        <mat-icon *ngIf="isCustomRangeSelected()" class="selected-check">check</mat-icon>
    </button>
</mat-menu>
